import { Link } from "react-router-dom";
import {
  Filter,
  Sparkles,
  MapPin,
  Building2,
  TrendingUp,
  Wallet,
  ShieldCheck,
  Zap,
} from "lucide-react";
import { HOME_QUICK_FILTERS } from "@/constants/testIds";

/**
 * Home Quick Intelligence Filters — a horizontally-scrollable row of
 * exploration shortcuts. Rendered as a Home page section directly beneath
 * the Search area (per Sprint 9b IA update). Not sticky, not part of the
 * navigation bar.
 *
 * Two behaviours:
 *   • Filters that map to listing query params → link to /opportunities?...
 *   • "الدول" / "القطاعات" → smooth-scroll anchor to the on-page section.
 */
const PILLS = [
  { key: "all",         label: "الكل",           icon: Filter,      to: "/opportunities" },
  { key: "new",         label: "فرص جديدة",      icon: Sparkles,    to: "/opportunities?time=today" },
  { key: "countries",   label: "الدول",          icon: MapPin,      to: "#countries",  anchor: true },
  { key: "industries",  label: "القطاعات",       icon: Building2,   to: "#industries", anchor: true },
  { key: "top-scored",  label: "الأعلى تقييماً",  icon: TrendingUp,  to: "/opportunities?sort=score-desc" },
  { key: "low-capital", label: "رأس مال منخفض",  icon: Wallet,      to: "/opportunities?label=low-capital" },
  { key: "low-risk",    label: "منخفضة المخاطر", icon: ShieldCheck, to: "/opportunities?risk=none" },
  { key: "fast",        label: "سريعة التنفيذ",  icon: Zap,         to: "/opportunities?time=urgent" },
];

const pillClass =
  "inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-surface-200 bg-white px-4 py-2 text-sm font-medium text-ink-700 transition-all hover:-translate-y-px hover:border-fursa-300 hover:bg-fursa-50 hover:text-fursa-700 hover:shadow-sm";

export const QuickFilters = () => (
  <section
    data-testid={HOME_QUICK_FILTERS.root}
    aria-label="اختصارات الاستكشاف السريعة"
    className="bg-surface-50"
  >
    <div className="no-scrollbar mx-auto max-w-7xl overflow-x-auto px-4 pb-8 sm:px-6 lg:px-8">
      <div className="flex w-max items-center gap-2">
        {PILLS.map(({ key, label, icon: Icon, to, anchor }) => {
          const testId = HOME_QUICK_FILTERS.pill(key);
          const content = (
            <>
              <Icon className="h-3.5 w-3.5" strokeWidth={1.75} />
              {label}
            </>
          );
          return anchor ? (
            <a key={key} href={to} data-testid={testId} className={pillClass}>
              {content}
            </a>
          ) : (
            <Link key={key} to={to} data-testid={testId} className={pillClass}>
              {content}
            </Link>
          );
        })}
      </div>
    </div>
  </section>
);
